import { render, staticRenderFns } from "./TicketDetailTicView.vue?vue&type=template&id=5e98aa4e&scoped=true"
import script from "./TicketDetailTicView.vue?vue&type=script&lang=js"
export * from "./TicketDetailTicView.vue?vue&type=script&lang=js"
import style0 from "./TicketDetailTicView.vue?vue&type=style&index=0&id=5e98aa4e&prod&lang=scss"
import style1 from "./TicketDetailTicView.vue?vue&type=style&index=1&id=5e98aa4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e98aa4e",
  null
  
)

export default component.exports